import React from "react";
import ProductService from "services/product";

import { connect } from "react-redux";
import { load } from "reducers/product";

class Product extends React.Component {
  productService = new ProductService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.productService
      .getAll()
      .then(({ data }) => this.props.load(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { load })(Product);
